import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import Link from 'components/links/Link';

export default function FileLink({url, label}) {
  const filename = decodeURIComponent(url?.substring(url.lastIndexOf('/') + 1));
  const btnDisplayType = label === 'Supplement' ? 'btn-outline-primary' : 'btn-primary';
  return (
    <div>
      <span className="mr-2">{label}</span>
      <Link className={clsx('btn', btnDisplayType)} href={url}>
        <FontAwesomeIcon icon="fa-regular fa-file-lines" />
        {filename}
      </Link>
    </div>
  );
}
